import { createApp } from 'vue';

import CvPrintView from 'JIX/components/cv/CvPrintView.vue';

const stash = window.Stash['cv/print_view'];
const print = stash.print;
delete stash.print;


const app = createApp(CvPrintView, { ...stash });
app.mount('.cv-content-personal');

if (print) {
    window.print();
}
